export default __webpack_public_path__ + "static/media/arcadiusBranding@2x.8129b6f0.jpg";